import '../../global.extensions';
export var BASE_TABLE_EVENTS = {
    REFRESH_ON_NEW_CA_OFFER: 'REFRESH_ON_NEW_CA_OFFER',
    REFRESH_ON_ACCEPT_OFFER: 'REFRESH_ON_ACCEPT_OFFER',
    SOFT_REFRESH: 'SOFT_REFRESH',
    REFRESH_DATA: 'REFRESH_DATA',
};
export * from '../context.store.types';
